import {
  PLAY_LIST_VIDEO_SORT_LOCAL_STORAGE_KEY,
  PlayListVideoSortType,
  PLAY_LIST_VIDEO_SORT_LIST,
} from '../../src/features/play_list/components/buttons/PlayListVideoSortButton/constants'

export const getPlayListVideoSort = (): PlayListVideoSortType | null => {
  if (typeof window === 'undefined') {
    return null
  }

  const value = window.localStorage.getItem(
    PLAY_LIST_VIDEO_SORT_LOCAL_STORAGE_KEY,
  ) as PlayListVideoSortType

  if (value && PLAY_LIST_VIDEO_SORT_LIST.includes(value)) {
    return value
  }

  return null
}

export const setPlayListVideoSort = (sortType: PlayListVideoSortType): void => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(PLAY_LIST_VIDEO_SORT_LOCAL_STORAGE_KEY, sortType)
  }
}
